import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { ModifySingleServerSettingsDialog } from '../../../components/server-settings/modify-server-settings-dialog-single'
import {
  ServerSettingsDialogProps,
  ServerSettingsMutationProps
} from '../../../components/server-settings/shared'
import { Predicate, Predicates } from '../../../ng/components/validation'

interface BridgeProps
  extends ServerSettingsDialogProps,
    ServerSettingsMutationProps {
  serverId: string
  organizationId: string
  isReadOnly: boolean
}

function Bridge({
  organizationId,
  serverId,
  closeDialog,
  isOpen,
  agentFeatures,
  protect,
  isFreemium,
  refresh,
  isReadOnly
}: BridgeProps) {
  return hasNeededProps({
    organizationId,
    serverId,
    isOpen,
    agentFeatures,
    protect,
    isFreemium
  }) ? (
    <ModifySingleServerSettingsDialog
      organizationID={organizationId}
      serverID={serverId}
      closeDialog={closeDialog}
      isOpen={isOpen}
      agentFeatures={agentFeatures}
      protect={protect}
      isFreemium={isFreemium}
      refresh={refresh}
      isReadOnly={isReadOnly}
    />
  ) : (
    <></>
  )
}

const hasNeededProps: Predicate<Partial<BridgeProps>> = Predicates.hasShape({
  organizationId: Predicates.isString,
  serverId: Predicates.isString,
  agentFeatures: Predicates.isArray,
  protect: Predicates.isBoolean,
  isFreemium: Predicates.isBoolean
})

export const reactModifySingleServerSettingsDialog =
  createNgReactBridgeDirective(
    'reactModifySingleServerSettingsDialog',
    [],
    Bridge,
    [
      'organizationId',
      'serverId',
      'closeDialog',
      'isOpen',
      'refresh',
      'agentFeatures',
      'protect',
      'isFreemium',
      'isReadOnly'
    ]
  )
